// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-no-rows-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.custom-no-rows-overlay-svg {
    width: 120;
    height: 100;
}

.ant-empty-img-1-light {
    fill: #aeb8c2;
}
.ant-empty-img-2-light {
    fill: #f5f5f7;
}
.ant-empty-img-3-light {
    fill: #dce0e6;
}
.ant-empty-img-4-light {
    fill: #fff;
    transform: translate(149.65 15.383);
}
.ant-empty-img-5-light {
    fill: #f5f5f5;
    fill-opacity: 0.8;
}

.ant-empty-img-1-other {
    fill: #262626;
}
.ant-empty-img-2-other {
    fill: #595959;
}
.ant-empty-img-3-other {
    fill: #434343;
}
.ant-empty-img-4-other {
    fill: #1c1c1c;
    transform: translate(149.65 15.383);
}
.ant-empty-img-5-other {
    fill: #fff;
    fill-opacity: 0.08;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/entityTable/CustomNoRowsOverlay.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mCAAmC;AACvC;AACA;IACI,UAAU;IACV,kBAAkB;AACtB","sourcesContent":[".custom-no-rows-overlay {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.custom-no-rows-overlay-svg {\n    width: 120;\n    height: 100;\n}\n\n.ant-empty-img-1-light {\n    fill: #aeb8c2;\n}\n.ant-empty-img-2-light {\n    fill: #f5f5f7;\n}\n.ant-empty-img-3-light {\n    fill: #dce0e6;\n}\n.ant-empty-img-4-light {\n    fill: #fff;\n    transform: translate(149.65 15.383);\n}\n.ant-empty-img-5-light {\n    fill: #f5f5f5;\n    fill-opacity: 0.8;\n}\n\n.ant-empty-img-1-other {\n    fill: #262626;\n}\n.ant-empty-img-2-other {\n    fill: #595959;\n}\n.ant-empty-img-3-other {\n    fill: #434343;\n}\n.ant-empty-img-4-other {\n    fill: #1c1c1c;\n    transform: translate(149.65 15.383);\n}\n.ant-empty-img-5-other {\n    fill: #fff;\n    fill-opacity: 0.08;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
